import React from 'react';
import { Button } from '@/components/ui/Button';
import { Card, CardContent } from '@/components/ui/Card';
import { LoadingSpinner } from '@/components/ui/LoadingSpinner';
import { MSAService } from '@/types';
import { ServiceCard } from '@/components/services/management/common/ServiceCard';
import { HealthStatus } from '@/types/health';

interface SubscribedServicesTabProps {
  subscribedServices: MSAService[];
  servicesLoading: boolean;
  healthStatuses: Record<number, HealthStatus>;
  onRefresh: () => void;
  onServiceClick: (service: MSAService, event?: React.MouseEvent) => void;
  onConnect?: (service: MSAService) => void;
}

export const SubscribedServicesTab: React.FC<SubscribedServicesTabProps> = ({
  subscribedServices,
  servicesLoading,
  healthStatuses,
  onRefresh,
  onServiceClick,
  onConnect,
}) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="text-xl font-semibold text-gray-900">구독중 서비스</h3>
          <p className="text-gray-600 text-sm">현재 사용 가능한 서비스입니다</p>
        </div>
        <Button onClick={onRefresh} variant="outline" size="sm">
          새로고침
        </Button>
      </div>

      {servicesLoading ? (
        <div className="flex items-center justify-center h-32">
          <LoadingSpinner size="md" message="서비스를 불러오는 중..." />
        </div>
      ) : subscribedServices.length === 0 ? (
        <Card>
          <CardContent className="py-12 text-center">
            <p className="text-gray-500">구독중인 서비스가 없습니다.</p>
            <p className="text-sm text-gray-400 mt-2">
              서비스 검색 탭에서 서비스를 구독해보세요.
            </p>
          </CardContent>
        </Card>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {subscribedServices.map((service) => (
            <ServiceCard
              key={service.id}
              service={service}
              healthStatuses={healthStatuses}
              showStatusBadge={false}
              onServiceClick={onServiceClick}
              onConnect={onConnect}
            />
          ))}
        </div>
      )}
    </div>
  );
};

